import { FIAT_CURRENCIES, USD_PEGGED_STABLE_COINS } from "constants/converter";

export const checkForUSDStableCoin = (coin: string) => {
  if (!coin) {
    return false;
  }
  return USD_PEGGED_STABLE_COINS.includes(coin.toUpperCase());
};

export const isFiatSymbol = (coin: string) => {
  if (!coin) {
    return false;
  }
  return FIAT_CURRENCIES.includes(coin.toUpperCase());
};

export const isCryptoSymbol = (coin: string) => {
  if (!coin) {
    return false;
  }
  return !FIAT_CURRENCIES.includes(coin.toUpperCase());
};
